import { useQuery } from '@tanstack/react-query';

import { subscriptionBillingService } from '@/services/subscription-billing.service';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Jumlah bukti pembayaran langganan yang menunggu diperiksa.
 *
 * Dipakai sidebar untuk menandai menu Bukti Pembayaran, dengan alasan yang
 * sama seperti penanda pendaftaran: lembaga yang sudah mentransfer sedang
 * menunggu masa berlakunya diperpanjang, dan selama buktinya belum diperiksa
 * ia tetap terhitung menunggak. Tanpa penanda yang mengikuti ke setiap layar,
 * satu-satunya cara mengetahuinya adalah sengaja membuka halamannya.
 */
export function usePendingSubscriptionConfirmationCount(): number {
  const canRead = useAuthStore((state) => state.hasPermission('subscriptionConfirmation.read'));

  const { data } = useQuery({
    queryKey: ['subscription-pending-confirmations'],
    queryFn: () => subscriptionBillingService.pendingCount(),
    enabled: canRead,
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
    retry: false,
  });

  return data ?? 0;
}
